import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArmchair1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "armchair-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.75,12.75V9a8.25,8.25,0,0,1,16.5,0v3.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.25,12.75a3,3,0,0,0-3,3H6.75a3,3,0,0,0-3-3H2.25a1.5,1.5,0,0,0,0,3,1.5,1.5,0,0,1,1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5v-3a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,0,0-3Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.25,
			y1: 21.75,
			x2: 5.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18.75,
			y1: 21.75,
			x2: 18.75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 10.5,
			y1: 7.5,
			x2: 13.5,
			y2: 10.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 13.5,
			y1: 7.5,
			x2: 10.5,
			y2: 10.5
		})
	]
});
export default SvgArmchair1;
